import TopTips from './src/TopTips'

export default TopTips
